import AbstractScene from './AbstractScene.js';
import { TextContents } from '../consts/TextContents.js';
import { Colors } from '../consts/Colors.js';
import ButtonRounded from '../prefabs/buttons/ButtonRounded.js';
import TraductionManager from '../prefabs/TraductionManager.js';

export default class GameOver extends AbstractScene {
    constructor() {
        super({
            key: 'GameOver',
        });
    }
    init(data) {
        this._init(data);

        this.traductionManager = new TraductionManager();
    }

    preload() {
        this._preload();
    }

    create() {
        this.background = this.add
            .image(0, 0, 'backMenu')
            .setOrigin(0)
            .setDisplaySize(this.width, this.height);
        this.backShadow = this.add
            .rectangle(0, 0, this.width, this.height, Colors.Elmt.DeepBlue, 0.9)
            .setOrigin(0);
        this.introBackground = this.add
            .rectangle(
                this.width / 2,
                this.height / 2,
                850 * this.game.data.scaleX,
                400 * this.game.data.scaleY,
                Colors.Elmt.White,
            )
            .setOrigin(0.5, 0.5);

        let title = {
            text: this.traductionManager.getText(TextContents.endTitleLoose.text),
            config: TextContents.endTitleLoose.config,
        };

        this.title = this.createTextElement(
            this.game.data.langue === 'ara' ? this.width / 2 + 320 : this.width / 2,
            this.height / 2,
            title,
        );

        this.introBtn = this.add.existing(
            new ButtonRounded(
                this,
                this.width / 2,
                this.height / 2 + 180 * this.game.data.scaleY,
                240 * 1.2 * this.game.data.scaleX,
                96 * 1.5 * this.game.data.scaleY,
                this.traductionManager.getText(TextContents.btnEnd.text),
                Colors.Text.White,
                Colors.Elmt.MiddleBlue,
                false,
                Colors.Text.Blue,
                null,
            ),
        );
        this.introBtn.setInteractive({ useHandCursor: true });
        this.introBtn.on('pointerup', (e) => {
            this.game.data.level = 0;
            this.game.data.errorsCount = 0;
            this.game.data.quizContents = this.game.data.quizContents.sort(
                () => 0.5 - Math.random(),
            );
            this.game.data.chronoDuration = 90;
            this.game.data.chronoText = '1:30';
            this.scene.start('Game');
        });
    }
}
